import { useEffect } from 'react';

/**
 * Sets document title, meta tags, Open Graph, canonical, and JSON-LD for public pages.
 */
export default function SeoHead({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://services.knls.in/logo192.png',
  jsonLd,
}) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const nodes = [];

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      if (created) nodes.push(el);
    };

    setMeta('name', 'description', description);
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:site_name', 'Loksy');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);

    let canonical = document.head.querySelector('link[rel="canonical"][data-seo="1"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.dataset.seo = '1';
      document.head.appendChild(canonical);
      nodes.push(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    let scriptEl = null;
    if (jsonLd) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.dataset.seo = '1';
      scriptEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(scriptEl);
      nodes.push(scriptEl);
    }

    return () => {
      document.title = previousTitle;
      nodes.forEach((el) => el.parentNode?.removeChild(el));
    };
  }, [title, description, canonicalUrl, ogImage, jsonLd]);

  return null;
}
